module.exports = __webpack_public_path__ + "img/compressed-2018234352479113216.7dab4a92.png";